import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const Contact = () => (
  <div
    style={{
      padding: '1rem',
      lineHeight: 1.7,
      textAlign: 'left',
      maxWidth: '820px',
      margin: '0 auto'
    }}
  >
    {/* SEO */}
    <Helmet>
      <title>お問い合わせ | トレイルランニングシミュレータ</title>

      {/* 🚫 インデックスさせない */}
      <meta name="robots" content="noindex, nofollow" />

      {/* 🔗 canonical をトップページへ向ける */}
      <link rel="canonical" href="https://trailrunsim.com/" />

      <meta
        name="description"
        content="TrailRunSim に関するお問い合わせはこちらのフォームから送信できます。GPX、ペース計算、レース戦略などの質問も歓迎します。TrailRunSim のお問い合わせページです。GPX解析、ペース計算、標高グラフ、3Dコースビュー、レース戦略などに関する質問や不具合報告を受け付けています。"
      />
      <meta
        name="keywords"
        content="トレラン, トレイルランニング, シミュレーター, お問い合わせ, GPX, レース戦略"
      />
    </Helmet>

    {/* 🍏 タイトル */}
    <h2>お問い合わせ</h2>

      <p style={{ margin: '0.6rem 0 1.2rem', color: '#444' }}>
        TrailRunSim は、トレイルランニングのレース戦略づくりを支援するために、
        GPX解析・ペース計算・累積標高の可視化などを行うオンラインシミュレーターです。
        本ページでは、サービスの利用方法に関する質問、機能改善のご要望、動作不具合の報告、
        コースデータの取り扱いに関する相談などを受け付けています。
        初めて利用する方や、レース前のペース設定に悩んでいる方、レースの追加依頼などのお問い合わせをいただいています。
      </p>

      <p style={{ margin: '0.6rem 0 1.2rem', color: '#444' }}>
        本シミュレータに関するご意見・ご要望・不具合の報告などがございましたら、お気軽にご連絡ください。
        利用方法に関するお問い合わせにもできる限り対応いたします。
        下記の Google フォームより内容をご送信ください。
      </p>

    {/* 🍏 お問い合わせフォーム（Apple風カード） */}
    <div
      style={{
        marginTop: '1.6rem',
        padding: '1rem',
        background: 'rgba(255,255,255,0.55)',
        borderRadius: '12px'
      }}
    >
      <h3 style={{ marginTop: 0 }}>お問い合わせフォーム</h3>

      <p style={{ margin: '0.4rem 0 1rem', color: '#444' }}>
        Google フォームを利用してお問い合わせを受け付けています。
        必要事項をご入力のうえ送信してください。
      </p>

      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSfopt1xg4KqkcZnfUUHe9jJ0LxPrm0ddKr3HaJJsNfGdZohUg/viewform?embedded=true"
        width="100%"
        height="800"
        frameBorder="0"
        marginHeight="0"
        marginWidth="0"
        title="お問い合わせフォーム"
        style={{
          borderRadius: '10px',
          background: '#fff'
        }}
      >
        読み込んでいます…
      </iframe>
    </div>

    {/* 🍏 関連リンク */}
    <div
      style={{
        marginTop: '2rem',
        padding: '1rem',
        background: 'rgba(255,255,255,0.55)',
        borderRadius: '12px'
      }}
    >
      <h3 style={{ marginTop: 0 }}>関連ページ</h3>
      <p style={{ margin: '0.4rem 0 1rem', color: '#444' }}>
        TrailRunSim をより深く活用したい方へ、関連ページをご案内します。
      </p>

      <ul style={{ lineHeight: 1.7 }}>
        <li>
          <Link to="/" style={{ color: '#007aff', fontWeight: 600 }}>
            トップページ（シミュレーターへ）
          </Link>
        </li>
        <li>
          <Link to="/how-to-use" style={{ color: '#007aff', fontWeight: 600 }}>
            使い方ガイド｜3分で完走計画
          </Link>
        </li>
        <li>
          <Link to="/privacy" style={{ color: '#007aff', fontWeight: 600 }}>
            プライバシーポリシー
          </Link>
        </li>
      </ul>
    </div>

    {/* 🍏 注意書き */}
    <p style={{ marginTop: '1.6rem', fontSize: '0.9rem', color: '#555' }}>
      ※返信には数日いただく場合があります。ご了承ください。
    </p>
  </div>
);

export default Contact;
